import * as types from './types';
import fetchData from '../../../shared/helpers/fetchData';
import fetchOptions from '../../../shared/helpers/fetchOptions';


export const receiveQuery = fallbackData => ({
  type: types.RECEIVE_QUERY_RESULTS,
  fallbackData,
});

export const queryData = function queryDataAll(url) {
  return function queryData(dispatch) {
    const options = fetchOptions('getWithCredentials');
    const handlers = {
      successHandler: receiveQuery,
      dispatch,
    };

    return fetchData(url, options, handlers);
  };
};
